<template>
  <div id="webTabbar" :class="{ 'webTabbar-hidden': isHidden }">
    <div class="wbt-model no-copy max-width">
      <!-- 所有产品按钮 -->
      <div class="wbt-model-menu" @mouseleave="func_leave_menu" v-if="false">
        <div
          class="wbt-model-menu-btn font-14 fontweight-bo bgcolor-gradient-right"
          @mouseenter="func_enter_menu"
        >
          <img class="wbt-model-menu-btn-icon" src="@/assets/icon/world.png" />
          <div>所有产品分类</div>
        </div>
        <!-- 产品模块 -->
        <div class="wbt-model-menu-model">
          <!-- 一级菜单 -->
          <div
            :class="{
              'wbt-model-menu-mod-first': true,
              'wbt-model-menu-mod-first-show':
                wtb_left_menu_show || wtb_left_menu_level2.length > 0,
            }"
          >
            <!-- 顶部占位元素 -->
            <div
              class="wbt-model-menu-mod-fir-nulltop"
              @mouseenter="func_enter_menu_first"
            ></div>
            <template v-for="(item, index) in wtb_left_menu_level1">
              <div
                :key="item.id"
                class="wbt-model-menu-mod-fir-line font-16"
                :data-index="index"
                @mouseenter="func_enter_menu_first"
              >
                <img class="wbt-model-menu-mod-fir-li-icon" :src="item.icon" />
                <div class="wbt-model-menu-mod-fir-li-name font-16">
                  {{ item.name }}
                </div>
                <img
                  class="wbt-model-menu-mod-fir-li-more"
                  src="@/assets/icon/more.png"
                />
              </div>
            </template>
            <!-- 底部占位元素 -->
            <div
              class="wbt-model-menu-mod-fir-nullbottom"
              @mouseenter="func_enter_menu_first"
            ></div>
          </div>
          <!-- 二级菜单 -->
          <div
            v-if="wtb_left_menu_level2.length > 0"
            class="wbt-model-menu-mod-second"
          >
            <template v-for="(item, index) in wtb_left_menu_level2">
              <div
                v-if="item.name"
                :key="item.id"
                class="wbt-model-menu-mod-sec-view font-hover"
                :data-index="index"
                @click="func_toOffer"
              >
                {{ item.name }}
              </div>
              <!-- 换行元素 -->
              <div
                v-else
                :key="item.id"
                class="wbt-model-menu-mod-sec-view-null"
              ></div>
            </template>
          </div>
        </div>
      </div>

      <div
        v-for="(item, index) in wtb_list"
        :key="item.id"
        :class="{
          'wbt-model-view font-16': true,
          'wbt-model-view-trolley': item.id === 'wtb_trolley',
        }"
      >
        <span
          :class="{
            'wbt-model-view-span font-hover': true,
            'wbt-model-view-span-closeBorder': !item.choose,
            'color fontweight-bo border-color': item.choose,
          }"
         
          @click="func_tabbar(index, 1)"
          >{{ item.name }}
        </span>

        <div v-if="item.icon" class="wbt-model-view-icon">
          <img class="wbt-model-view-icon-img" :src="item.icon" />
          <div class="wbt-model-view-icon-num">{{ item.num }}</div>
        </div>
      </div>
      <div
        v-for="(item, index) in wtb_list_h5"
        :key="item.url"
        :class="{
          'wbt-model-view-h5 font-16': true,
          'wbt-model-view-trolley-h5': item.id === 'wtb_trolley',
        }"
      >
        <span
          :class="{
            'wbt-model-view-span font-hover': true,
            'wbt-model-view-span-closeBorder': !item.choose,
            'color fontweight-bo border-color': item.choose,
          }"
          @click="func_tabbar(index, 2)"
          >{{ item.name }}
        </span>

        <div v-if="item.icon" class="wbt-model-view-icon">
          <img class="wbt-model-view-icon-img" :src="item.icon" />
          <div class="wbt-model-view-icon-num">{{ item.num }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import iconTrolley from "@/assets/icon/trolley.png";
import cXinfeng from "@/assets/icon/c_xinfeng.png";
import cDanzhang from "@/assets/icon/c_danzhang.png";
import cHongbao from "@/assets/icon/c_hongbao.png";
import cKatao from "@/assets/icon/c_katao.png";
import cQita from "@/assets/icon/c_qita.png";
import cFeibiao from "@/assets/icon/c_feibiao.png";
import cWenjiandai from "@/assets/icon/c_wenjiandai.png";

import p01 from "@/assets/order/p_01.jpg";
import p02 from "@/assets/order/p_02.jpg";
import p03 from "@/assets/order/hongbao/cyhb.jpg";
import p04 from "@/assets/order/p_04.jpg";
import p05 from "@/assets/order/p_05.jpg";
import p07 from "@/assets/order/p_07.jpg";
import p08 from "@/assets/order/p_08.png";
import p10 from "@/assets/order/p_10.jpg";
import p11 from "@/assets/order/p_11.jpg";
import p12 from "@/assets/order/p_12.jpg";
import p13 from "@/assets/order/p_13.jpg";
import p14 from "@/assets/order/p_14.png";
import p15 from "@/assets/order/p_15.png";
import p16 from "@/assets/order/p_16.png";
import p17 from "@/assets/order/p_17.jpg";
import p18 from "@/assets/order/p_18.jpg";
import p19 from "@/assets/order/p_19.jpg";
import p20 from "@/assets/order/p_20.jpg";
import p21 from "@/assets/order/BK1.png"
export default {
  name: "webTabbar",
  props: {
    isHidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      userinfo:{head:true},
      wtb_left_menu_show: false,
      wtb_left_menu_level1: [
        //一级菜单
        {
          name: "信封报价",
          icon: cXinfeng,
          data: [
            { name: "标准信封", oef: "pidenv_xf", choose: false, icon: p18 },
            {
              name: "现货普通信封",
              oef: "pidcards_ptxf",
              choose: false,
              icon: p16,
            },
            {
              name: "珠光纸烫金信封",
              oef: "pidcards_gdty",
              choose: false,
              icon: p14,
            },
            {
              name: "高端现货信封",
              oef: "pidcards_gd",
              choose: false,
              icon: p13,
            },
          ],
        },
        {
          name: "信封报价",
          icon: cXinfeng,
          data: [
            { name: "专版信封", oef: "pidenv_lsf", choose: false, icon: p18 },
            { name: "", did: "" },
            { name: "药品袋", oef: "pidenv_lsf", choose: false },
            { name: "相片袋", oef: "pidenv_lsf", choose: false },
            { name: "工资袋", oef: "pidenv_lsf", choose: false },
          ],
        },
        {
          name: "红包报价",
          icon: cHongbao,
          data: [
            {
              name: "专版红包",
              oef: "pidredenv_zbhb",
              choose: false,
              icon: p03,
            },
            {
              name: "标准红包",
              oef: "pidredenv_hbhb",
              choose: false,
              icon: p03,
            },
          ],
        },
        {
          name: "文件袋报价",
          icon: cWenjiandai,
          data: [
            {
              name: "标准文件袋",
              oef: "pidfilepoc_hbwjd",
              choose: false,
              icon: p05,
            },
            {
              name: "专版文件袋",
              oef: "pidfilepoc_zbwjd",
              choose: false,
              icon: p05,
            },
          ],
        },
        {
          name: "卡套报价",
          icon: cKatao,
          data: [
            {
              name: "标准房卡套",
              oef: "pidcards_hbfkt",
              choose: false,
              icon: p01,
            },
            {
              name: "标准筷子套",
              oef: "pidcards_hbkzt",
              choose: false,
              icon: p04,
            },

            { name: "封套", oef: "pidcards_hbft", choose: false, icon: p02 },
            { name: "", did: "" },
            {
              name: "专版筷子套",
              oef: "pidcards_zbkzt",
              choose: false,
              icon: p04,
            },
            {
              name: "专版房卡套",
              oef: "pidcards_zbfkt",
              choose: false,
              icon: p01,
            },
            {
              name: "专版封套",
              oef: "pidcards_zbft",
              choose: false,
              icon: p02,
            },
          ],
        },
        {
          name: "宣传单报价",
          icon: cDanzhang,
          data: [
            {
              name: "专版宣传单",
              oef: "pidleaflet_zbxcd",
              choose: false,
              icon: p07,
            },
            {
              name: "专版单张",
              oef: "pidleaflet_zbhb",
              choose: false,
              icon: p07,
            },
          ],
        },
        {
          name: "其他产品报价",
          icon: cQita,
          data: [
            {
              name: "快递封",
              oef: "pidcards_kuaidifeng",
              choose: false,
              icon: p19,
            },
          ],
        },
        {
          name: "其他产品报价",
          icon: cQita,
          data: [
            {
              name: "电脑打印联单",
              oef: "pidcards_pcliandan",
              choose: false,
              icon: p12,
            },
          ],
        },
        {
          name: "其他产品报价",
          icon: cQita,
          data: [
            {
              name: "无碳联单",
              oef: "pidcards_wtliandan",
              choose: false,
              icon: p17,
            },
          ],
        },
        {
          name: "其他产品报价",
          icon: cQita,
          data: [
            {
              name: "标准档案盒",
              oef: "pidcards_bzdah",
              choose: false,
              icon: p20,
            },
          ],
        },
        {
          name: "其他产品报价",
          icon: cQita,
          data: [
            {
              name: "会计用品",
              oef: "pidcards_kjyp",
              choose: false,
              icon: p11,
            },
          ],
        },
        {
          name: "其他产品报价",
          icon: cQita,
          data: [
            {
              name: "体检报告",
              oef: "pidcards_tjbg",
              choose: false,
              icon: p11,
            },
          ],
        },
        {
          name: "其他产品报价",
          icon: cQita,
          data: [
            {
              name: "便笺表格",
              oef: "pidcards_bzbg",
              choose: false,
              icon: p10,
            },
          ],
        },
        {
          name: "其他产品报价",
          icon: cQita,
          data: [
            {
              name: "白卡盒",
              oef: "pidcards_baikahe",
              choose: false,
              icon: p21,
            },
          ],
        },
        {
          name: "特殊产品",
          icon: cFeibiao,
          data: [
            { name: "特殊产品", oef: "pidnon_fb", choose: false, icon: p08 },
          ],
        },
      ],
      wtb_left_menu_level2: [], //二级菜单
      wtb_list: [
        { name: "网站首页", id: "wtb_home", url: "home", choose: false },
        { name: "报价下单", id: "wtb_order", url: "order", choose: false },
        {
          name: "批量下单",
          id: "wtb_orderBatch",
          url: "orderBatch",
          choose: false,
        },
        {
          name: "模板下载",
          id: "wtb_templater",
          url: "tempDownload",
          choose: false,
        },
        { name: "下单必读", id: "wtb_read", url: "orderRead", choose: false },
        {
          name: "联系方式",
          id: "wtb_contact",
          url: "contactWay",
          choose: false,
        },
        {
          name: "我的购物车",
          id: "wtb_trolley",
          url: "trolley",
          choose: false,
          icon: iconTrolley,
          num: 0,
        },
      ],
      wtb_list_h5: [
        { name: "网站首页", id: "wtb_home", url: "home", choose: false },
        { name: "报价下单", id: "wtb_order", url: "order", choose: false },
        {
          name: "我的订单",
          id: "orderManege",
          url: "orderManege",
          choose: false,
        },
        { name: "下单必读", id: "wtb_read", url: "orderRead", choose: false },
      ],
    };
  },
  methods: {
    func_loginPlate() {
      this.$parent.func_appLoginOut();
    },
    func_tabbar(index, num) {
      if (num === 1) {
        if (typeof index === "number" && !this.wtb_list[index]["choose"]) {
          let count = -1;
          for (let i in this.wtb_list) {
            if (this.wtb_list[i]["choose"]) {
              count = i;
              break;
            }
          }
          if (count !== -1) this.wtb_list[count]["choose"] = false;
          this.wtb_list[index]["choose"] = true;

          this.$router.push({
            name: this.wtb_list[index]["url"],
          });
        }
      } else if (num === 2) {
        if (typeof index === "number" && !this.wtb_list_h5[index]["choose"]) {
          let count = -1;
          for (let i in this.wtb_list_h5) {
            if (this.wtb_list_h5[i]["choose"]) {
              count = i;
              break;
            }
          }
          if (count !== -1) this.wtb_list_h5[count]["choose"] = false;
          this.wtb_list_h5[index]["choose"] = true;

          this.$router.push({
            name: this.wtb_list_h5[index]["url"],
          });
        }
      }
    },
    // 根据当前路由，更新导航栏选择样式
    func_tabbarUp(isTrolley) {
      const trolley = this.STORAGE.get("g_trollerList");
      for (let i in this.wtb_list_h5) {
        if (this.wtb_list_h5[i]["id"] === "wtb_trolley") {
          if (trolley) this.wtb_list_h5[i]["num"] = trolley.length;
          else this.wtb_list_h5[i]["num"] = 0;

          break;
        }
      }

      /* 只更新购物车数量 */
      if (isTrolley) return;

      const route_name = this.$route.name;
      let route_index = -1;
      for (let i in this.wtb_list_h5) {
        if (
          this.wtb_list_h5[i]["choose"] &&
          this.wtb_list_h5[i]["url"] !== route_name
        ) {
          this.wtb_list_h5[i]["choose"] = false;
        }
        if (
          this.wtb_list_h5[i]["url"] === route_name &&
          !this.wtb_list_h5[i]["choose"]
        ) {
          route_index = i;
        }
      }
      if (route_index !== -1) this.wtb_list_h5[route_index]["choose"] = true;
    },
    // 进入一级菜单面板
    func_enter_menu() {
      this.wtb_left_menu_show = true;
    },
    // 离开整个动画面板
    func_leave_menu() {
      this.wtb_left_menu_show = false;
      this.wtb_left_menu_level2 = [];
    },
    // 进入一级菜单
    func_enter_menu_first(event) {
      const index = event.currentTarget.dataset.index;
      if (index !== undefined) {
        this.wtb_left_menu_level2 = this.wtb_left_menu_level1[index].data;
      } else {
        this.wtb_left_menu_level2 = [];
      }
    },
    // 从菜单栏-去报价
    func_toOffer(event) {
      let index = -1;
      let wtb_left_menu_level2 = false;
      if (event.constructor["name"] === "String") {
        // 来源处为"热门"
        for (let i in this.wtb_left_menu_level1) {
          let count = -1;
          for (let j in this.wtb_left_menu_level1[i]["data"]) {
            if (this.wtb_left_menu_level1[i]["data"][j]["oef"] === event) {
              index = j;
              wtb_left_menu_level2 = this.wtb_left_menu_level1[i]["data"];
              count += 1;
              break;
            }
          }
          if (count > -1) {
            break;
          }
        }
      } else {
        index = event.currentTarget.dataset.index;
      }

      if (wtb_left_menu_level2) {
        for (let i in wtb_left_menu_level2) {
          if (wtb_left_menu_level2[i]["choose"]) {
            wtb_left_menu_level2[i]["choose"] = false;
            break;
          }
        }
        wtb_left_menu_level2[index]["choose"] = true;
      } else {
        for (let i in this.wtb_left_menu_level2) {
          if (this.wtb_left_menu_level2[i]["choose"]) {
            this.wtb_left_menu_level2[i]["choose"] = false;
            break;
          }
        }
        this.wtb_left_menu_level2[index]["choose"] = true;
      }

      let arr = [];
      if (wtb_left_menu_level2) {
        for (let i in wtb_left_menu_level2) {
          if (
            wtb_left_menu_level2[i]["name"] &&
            wtb_left_menu_level2[i]["oef"]
          ) {
            arr.push(wtb_left_menu_level2[i]);
          }
        }
        // 判断是否有oef对应模板
        if (wtb_left_menu_level2[index]["oef"] === "xx") return;
      } else {
        for (let i in this.wtb_left_menu_level2) {
          if (
            this.wtb_left_menu_level2[i]["name"] &&
            this.wtb_left_menu_level2[i]["oef"]
          ) {
            arr.push(this.wtb_left_menu_level2[i]);
          }
        }
        // 判断是否有oef对应模板
        if (this.wtb_left_menu_level2[index]["oef"] === "xx") return;
      }

      this.STORAGE.set("g_order_menu", arr);
      if (
        event.constructor["name"] === "String" &&
        this.$route["name"] === "order"
      ) {
        return true;
      } else if (this.$route.name !== "order") {
        this.func_leave_menu();
        this.$router.push({
          name: "order",
        });
      } else {
        location.reload();
      }
    },
  },
  mounted() {
    this.func_tabbarUp();
    this.userinfo = this.STORAGE.get("g_userInfo");
    if (!this.$parent.isorder) {
      this.wtb_list = [
        { name: "印刷报价", id: "wtb_order", url: "order", choose: false },
        { name: "后台管理", id: "wtb_strategy", url: "strategy", choose: false },
      ];
      this.wtb_list_h5 = [
        { name: "网站首页", id: "wtb_home", url: "home", choose: false },
        { name: "印刷报价", id: "wtb_order", url: "order", choose: false },
      ];
    }
    // else {
    //   this.wtb_list = []
    //   this.wtb_list_h5 = []
    // }
  },
};
</script>
<style scoped>
@media only screen and (min-width: 480px) {
  #webTabbar {
    /* background:#ffffff; */
    background: #232830;
    width: 100%;
    box-shadow: 0px 14px 14px -20px #ccc;
    position: sticky;
    position: -webkit-sticky;
    top: 0px;
    z-index: 200;
  }
  .webTabbar-hidden {
    height: 0px;
    overflow: hidden;
  }
  .wbt-model {
    min-height: 46px;
    margin: 0 auto 10px auto;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding-right: 130px;
    position: relative;
  }

  .wbt-model-menu {
    width: 140px;
    height: 46px;
    margin: 0 20px 0 0;
    display: flex;
    align-items: center;
    position: relative;
  }
  .wbt-model-menu-btn {
    width: 100%;
    height: 100%;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
  .wbt-model-menu-btn-icon {
    width: 26px;
    height: 26px;
    margin-right: 2px;
  }
  /* 产品模块 */
  .wbt-model-menu-model {
    display: flex;
    position: absolute;
    top: 46px;
    left: 0;
  }
  .wbt-model-menu-mod-fir-nulltop {
    width: 100%;
    height: 10px;
  }
  .wbt-model-menu-mod-fir-nullbottom {
    width: 100%;
    height: 18px;
  }
  /* 一级菜单 */
  .wbt-model-menu-mod-first {
    background: #232830;
    width: 320px;
    height: 0;
    overflow: hidden;
    border-radius: 2px;
    transition: all 0.2s ease-in-out 0s;
  }
  .wbt-model-menu-mod-first-show {
    height: 420px;
    margin-top: 10px;
  }
  .wbt-model-menu-mod-fir-line {
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 16px 4px 16px 12px;
  }
  .wbt-model-menu-mod-fir-li-icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  .wbt-model-menu-mod-fir-li-name {
    width: 82%;
    color: #ffffff;
  }
  .wbt-model-menu-mod-fir-li-more {
    width: 14px;
    height: 14px;
  }
  /* 二级菜单 */
  .wbt-model-menu-mod-second {
    background: #ffffff;
    /* background:rgba(255, 255, 255, 0.8); */
    width: 640px;
    height: 420px;
    color: #666;
    margin-top: 10px;
    display: inline-flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 10px 16px 360px 16px;
    border-radius: 2px;
    box-shadow: 0 0 10px #aaaaaa;
    transition: all 0.2s ease-in-out 0s;
  }
  .wbt-model-menu-mod-sec-view {
    min-width: 137px;
    height: 36px;
    text-align: center;
    margin: 4px 6px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0 16px;
    border-radius: 2px;
    border: 1px solid #ccc;
    cursor: pointer;
  }
  .wbt-model-menu-mod-sec-view:hover {
    border-color: rgba(255, 104, 1, 1);
  }
  .wbt-model-menu-mod-sec-view-null {
    width: 100%;
    height: 0;
  }

  .wbt-model-view {
    width: 124px;
    height: 46px;
    color: #ffffff;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  .wbt-model-view-h5 {
    display: none;
  }
  /* 购物车 */
  .wbt-model-view-trolley {
    position: absolute;
    top: 0;
    right: 0;
  }
  .wbt-model-view-trolley-h5 {
    display: none;
  }
  .wbt-model-view-span {
    height: 100%;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    border-width: 0 0 2px 0;
    border-style: solid;
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    transition: all 0.2s linear 0s;
  }
  .wbt-model-view-span-closeBorder {
    border-color: #232830;
  }
  .wbt-model-view-icon {
    width: 20px;
    height: 20px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .wbt-model-view-icon-img {
    width: 100%;
    height: 100%;
  }
  .wbt-model-view-icon-num {
    background: rgba(255, 104, 1, 1);
    width: 18px;
    height: 16px;
    color: #ffffff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -6px;
    right: -10px;
  }
}
@media only screen and (max-width: 480px) {
  #webTabbar {
    /* background:#ffffff; */
    background: #232830;
    width: 100%;
    box-shadow: 0px 14px 14px -20px #ccc;
    position: sticky;
    position: -webkit-sticky;
    top: 0px;
    z-index: 200;
  }
  .webTabbar-hidden {
    height: 0px;
    overflow: hidden;
  }
  .wbt-model {
    min-height: 46px;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    position: absolute;
    position: fixed;
    bottom: 0;
    background: #232830;
  }

  .wbt-model-menu {
    width: 140px;
    height: 46px;
    margin: 0 20px 0 0;
    display: flex;
    align-items: center;
    position: relative;
  }
  .wbt-model-menu-btn {
    width: 100%;
    height: 100%;
    color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
  }
  .wbt-model-menu-btn-icon {
    width: 26px;
    height: 26px;
    margin-right: 2px;
  }
  /* 产品模块 */
  .wbt-model-menu-model {
    display: flex;
    position: absolute;
    top: 46px;
    left: 0;
  }
  .wbt-model-menu-mod-fir-nulltop {
    width: 100%;
    height: 10px;
  }
  .wbt-model-menu-mod-fir-nullbottom {
    width: 100%;
    height: 18px;
  }
  /* 一级菜单 */
  .wbt-model-menu-mod-first {
    background: #232830;
    width: 320px;
    height: 0;
    overflow: hidden;
    border-radius: 2px;
    transition: all 0.2s ease-in-out 0s;
  }
  .wbt-model-menu-mod-first-show {
    height: 420px;
    margin-top: 10px;
  }
  .wbt-model-menu-mod-fir-line {
    width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 16px 4px 16px 12px;
  }
  .wbt-model-menu-mod-fir-li-icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  .wbt-model-menu-mod-fir-li-name {
    width: 82%;
    color: #ffffff;
  }
  .wbt-model-menu-mod-fir-li-more {
    width: 14px;
    height: 14px;
  }
  /* 二级菜单 */
  .wbt-model-menu-mod-second {
    background: #ffffff;
    /* background:rgba(255, 255, 255, 0.8); */
    width: 640px;
    height: 420px;
    color: #666;
    margin-top: 10px;
    display: inline-flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    padding: 10px 16px 360px 16px;
    border-radius: 2px;
    box-shadow: 0 0 10px #aaaaaa;
    transition: all 0.2s ease-in-out 0s;
  }
  .wbt-model-menu-mod-sec-view {
    min-width: 137px;
    height: 36px;
    text-align: center;
    margin: 4px 6px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 0 16px;
    border-radius: 2px;
    border: 1px solid #ccc;
    cursor: pointer;
  }
  .wbt-model-menu-mod-sec-view:hover {
    border-color: rgba(255, 104, 1, 1);
  }
  .wbt-model-menu-mod-sec-view-null {
    width: 100%;
    height: 0;
  }

  .wbt-model-view {
    display: none;
  }
  .wbt-model-view-h5 {
    width: 25%;
    height: 46px;
    color: #ffffff;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }
  /* 购物车 */
  .wbt-model-view-trolley {
    display: none;
  }
  .wbt-model-view-trolley-h5 {
    position: absolute;
    top: 0;
    right: 0;
  }
  .wbt-model-view-span {
    height: 100%;
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    /* border-width:0 0 2px 0; border-style:solid; */
    cursor: pointer;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    transition: all 0.2s linear 0s;
  }
  .wbt-model-view-span-closeBorder {
    border-color: #232830;
  }
  .wbt-model-view-icon {
    width: 20px;
    height: 20px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .wbt-model-view-icon-img {
    width: 100%;
    height: 100%;
  }
  .wbt-model-view-icon-num {
    background: rgba(255, 104, 1, 1);
    width: 18px;
    height: 16px;
    color: #ffffff;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -6px;
    right: -10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/webTabbar.vue